module.exports = __webpack_public_path__ + "img/GH-kyujin-top-pa003.4d27ede2.webp";